// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ModelRegistryHistory-module__modelRegistryHistoryTabContainer--LGPzr{margin-top:52px;display:flex;justify-content:center}.ModelRegistryHistory-module__modelRegistryHistoryTabContainer--LGPzr h6{font-family:"Roboto";font-style:normal;font-size:14px;line-height:21px;margin:0}.ModelRegistryHistory-module__modelRegistryHistoryTabContainer--LGPzr p{font-family:"Roboto";font-style:normal;font-size:12px;line-height:18px;margin:0}.ModelRegistryHistory-module__modelRegistryHistoryTabContainer--LGPzr span{color:var(--primary-color)}.ModelRegistryHistory-module__modelRegistryHistoryTabContainer--LGPzr .MuiTimelineItem-missingOppositeContent:before{flex:0 !important}.ModelRegistryHistory-module__modelRegistryHistoryCardContainer--oeFje{display:flex;flex-direction:column;justify-content:center;border:1px solid var(--gray-2);border-bottom:none;line-height:1;background-color:0;color:#000;padding:10px 12px;min-height:67px}.ModelRegistryHistory-module__modelRegistryHistoryCardContainer--oeFje:first-of-type{border-top-left-radius:5px;border-top-right-radius:5px}.ModelRegistryHistory-module__modelRegistryHistoryCardContainer--oeFje:last-of-type{border-bottom-left-radius:5px;border-bottom-right-radius:5px;border-bottom:1px solid var(--gray-2)}.ModelRegistryHistory-module__modelRegistryHistoryCardContainer--oeFje .ds-avatar-outer-container{margin-right:12px}.ModelRegistryHistory-module__modelRegistryHistoryCardTitle--PkzUd{margin-bottom:5px !important}.ModelRegistryHistory-module__modelRegistryHistoryTimelineContainer--AjbkJ{max-width:1209px;width:100%}.ModelRegistryHistory-module__modelRegistryHistoryTimelineDot--xxMiY{padding:1px !important;box-shadow:none !important;background-color:var(--gray-5) !important}.ModelRegistryHistory-module__modelRegistryHistoryTimelineContent--r2eIQ{padding:0 31px 18px 31px !important}.ModelRegistryHistory-module__modelRegistryHistoryTimelineLine--hDlM_{background-color:var(--gray-line) !important;width:2px !important}.ModelRegistryHistory-module__modelRegistryHistoryTimelineGroupTitle--X9cPM{margin-bottom:18px !important;font-weight:400}.ModelRegistryHistory-module__modelRegistryHistoryTimelineItem--utdXC:last-child .ModelRegistryHistory-module__modelRegistryHistoryTimelineLine--hDlM_{display:none !important}.ModelRegistryHistory-module__modelRegistryHistoryTimelineItem--utdXC:last-child .ModelRegistryHistory-module__modelRegistryHistoryTimelineDot--xxMiY{padding:2px !important;box-shadow:none !important;border:1px solid var(--gray-5) !important;background:rgba(0,0,0,0) !important}.ModelRegistryHistory-module__modelRegistryHistoryWebhookContainer--FpLSS{display:flex;gap:5px;margin-left:33px;margin-top:3px}.ModelRegistryHistory-module__modelRegistryHistoryWebhookContainer--FpLSS .ModelRegistryHistory-module__modelRegistryHistoryWebhookStatusIcon--BjlXl{color:#f14668}.ModelRegistryHistory-module__modelRegistryHistoryWebhookContainer--FpLSS .ModelRegistryHistory-module__modelRegistryHistoryWebhookStatusIcon--BjlXl.ModelRegistryHistory-module__SUCCESS--O5tpx{color:#00d41f}.ModelRegistryHistory-module__modelRegistryHistoryWebhookContainer--FpLSS u{text-decoration:underline;cursor:pointer;text-decoration-skip-ink:none}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dsPrimaryBlue": `#5155f5`,
	"dsSecondaryBlue": `#e5e5fe`,
	"dsHoverBlue": `#3438d0`,
	"dsClickBlue": `#262ab5`,
	"dsClickBlue2": `#d3d4f0`,
	"dsClickBlue3": `#a8a9e1`,
	"dsClickBlue4": `#7c7fd2`,
	"dsClickBlue5": `#5154c3`,
	"dsBlack": `#191a1c`,
	"dsGray1": `#f5f7fa`,
	"dsGray2": `#eaecf2`,
	"dsGray3": `#dce0ea`,
	"dsGray4": `#b3b9c8`,
	"dsGray5": `#8c95a8`,
	"dsGray6": `#5f677e`,
	"dsGray7": `#3d4355`,
	"dsGrayMainHeader": `#373d4d`,
	"dsGrayLine": `#e2e2e2`,
	"dsGrayBackground": `#f4f4f5`,
	"dsWhite": `#fff`,
	"dsWarning": `#f14668`,
	"dsSuccess": `#00d41f`,
	"dsActionYellow": `#f3b32a`,
	"dsActionYellowLight": `#fef7e7`,
	"dsChartGreen": `#19a979`,
	"dsChartPink": `#ed4a7b`,
	"dsChartYellow": `#f4b400`,
	"dsChartPurple": `#945fcf`,
	"dsChartTurquoise": `#12a4b4`,
	"dsChartBlue": `#525df4`,
	"dsChartOrange": `#fb9341`,
	"dsChartBurgundy": `#bf399e`,
	"dsChartRed": `#ef6868`,
	"dsChartGrey": `#6c8893`,
	"dsChartDarkBlue": `#2e6497`,
	"dsChartOrangeLight": `#feddc3`,
	"dsChartLightBlue": `#5899da`,
	"dsTeamProRed": `#ff594c`,
	"dsFreeYellow": `#ffb42e`,
	"dsTeamsGreen": `#52aea4`,
	"dsTableRowHover": `#f7f8fa`,
	"dsTableNegativeHighlight": `#ffeae9`,
	"dsTableNegativeHighlightHover": `#ffe0df`,
	"dsSparklinePurple": `#777af7`,
	"dsPrimaryBlue100": `#f3f4fe`,
	"dsPrimaryBlue200": `#cfd0ff`,
	"dsPrimaryBlue300": `#8889f8`,
	"dsPrimaryBlue400": `#6c6ff7`,
	"dsPrimaryBlue500": `#575af5`,
	"dsPrimaryBlue600": `#4449f3`,
	"dsPrimaryBlue700": `#3339f1`,
	"dsPrimaryBlue800": `#1f29ef`,
	"dsPrimaryBlue900": `#1823de`,
	"dsPrimaryBlue1000": `#151fcc`,
	"dsMainHeader100": `#f9f9fa`,
	"dsMainHeader200": `#b5b7bc`,
	"dsMainHeader300": `#91959d`,
	"dsMainHeader400": `#7b7f89`,
	"dsMainHeader500": `#6b6f7b`,
	"dsMainHeader600": `#5e6370`,
	"dsMainHeader700": `#545967`,
	"dsMainHeader800": `#4b505f`,
	"dsMainHeader900": `#434958`,
	"dsMainHeader1000": `#3d4252`,
	"dsWarning100": `#fcdce3`,
	"dsWarning200": `#f9b5c2`,
	"dsWarning300": `#f46d88`,
	"dsWarning400": `#e44262`,
	"dsWarning500": `#c83a56`,
	"dsWarning600": `#b2344d`,
	"dsWarning700": `#a02f45`,
	"dsWarning800": `#922a3f`,
	"dsWarning900": `#852639`,
	"dsWarning1000": `#792334`,
	"modelRegistryHistoryTabContainer": `ModelRegistryHistory-module__modelRegistryHistoryTabContainer--LGPzr`,
	"modelRegistryHistoryCardContainer": `ModelRegistryHistory-module__modelRegistryHistoryCardContainer--oeFje`,
	"modelRegistryHistoryCardTitle": `ModelRegistryHistory-module__modelRegistryHistoryCardTitle--PkzUd`,
	"modelRegistryHistoryTimelineContainer": `ModelRegistryHistory-module__modelRegistryHistoryTimelineContainer--AjbkJ`,
	"modelRegistryHistoryTimelineDot": `ModelRegistryHistory-module__modelRegistryHistoryTimelineDot--xxMiY`,
	"modelRegistryHistoryTimelineContent": `ModelRegistryHistory-module__modelRegistryHistoryTimelineContent--r2eIQ`,
	"modelRegistryHistoryTimelineLine": `ModelRegistryHistory-module__modelRegistryHistoryTimelineLine--hDlM_`,
	"modelRegistryHistoryTimelineGroupTitle": `ModelRegistryHistory-module__modelRegistryHistoryTimelineGroupTitle--X9cPM`,
	"modelRegistryHistoryTimelineItem": `ModelRegistryHistory-module__modelRegistryHistoryTimelineItem--utdXC`,
	"modelRegistryHistoryWebhookContainer": `ModelRegistryHistory-module__modelRegistryHistoryWebhookContainer--FpLSS`,
	"modelRegistryHistoryWebhookStatusIcon": `ModelRegistryHistory-module__modelRegistryHistoryWebhookStatusIcon--BjlXl`,
	"SUCCESS": `ModelRegistryHistory-module__SUCCESS--O5tpx`
};
module.exports = ___CSS_LOADER_EXPORT___;
